import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@digdir/designsystemet-react';

import { OppvarmingBioenergi } from '../../../../../../types/registration/userInput';
import {
  AccentedTableRow,
  Capitalize,
  LeftBorderCell
} from '../../../../../expertRegistration/json/enhet/upload/fileReview/components/styledComponents';

interface OppvarmingBioEnergiProps {
  bioenergi: OppvarmingBioenergi | undefined;
}
export const OppvarmingBioEnergiView: FC<OppvarmingBioEnergiProps> = ({ bioenergi }) => {
  const { t } = useTranslation('', { keyPrefix: 'expertToolsJSON.summary.tekniskutstyr.oppvarming.bioenergi' });
  const { t: tCommon } = useTranslation('', { keyPrefix: 'expertToolsJSON.summary.common' });

  if (!bioenergi) {
    return null;
  }

  return (
    <Fragment>
      <AccentedTableRow $isSecondarySection>
        <TableCell colSpan={2}>{t('header')}</TableCell>
      </AccentedTableRow>
      {bioenergi.kamin && (
        <Fragment>
          <AccentedTableRow>
            <TableCell colSpan={2}>{t('kamin.label')}</TableCell>
          </AccentedTableRow>
          {bioenergi.kamin.installasjonsAr && (
            <TableRow>
              <TableCell>{t('kamin.installasjonsar')}</TableCell>
              <LeftBorderCell>{bioenergi.kamin.vetInstallasjonsAr ? bioenergi.kamin.installasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: bioenergi.kamin.installasjonsAr })}</LeftBorderCell>
            </TableRow>
          )}
          <TableRow>
            <TableCell>{t('kamin.termostatstyring.label')}</TableCell>
            <LeftBorderCell>{t(`kamin.termostatstyring.${bioenergi.kamin.termostatstyring}`)}</LeftBorderCell>
          </TableRow>
        </Fragment>
      )}

      {bioenergi.kjel && (
        <Fragment>
          <AccentedTableRow>
            <TableCell colSpan={2}>{t('kjel.label')}</TableCell>
          </AccentedTableRow>
          {bioenergi.kjel.installasjonsAr && (
            <TableRow>
              <TableCell>{t('kjel.installasjonsar')}</TableCell>
              <LeftBorderCell>{bioenergi.kjel.vetInstallasjonsAr ? bioenergi.kjel.installasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: bioenergi.kjel.installasjonsAr })}</LeftBorderCell>
            </TableRow>
          )}
          {bioenergi.kjel.bruk && (
            <TableRow>
              <TableCell>{t('kjel.bruk.label')}</TableCell>
              <LeftBorderCell>{t(`kjel.bruk.${bioenergi.kjel.bruk}`)}</LeftBorderCell>
            </TableRow>
          )}
          {bioenergi.kjel.varmesystemBruk && (
            <TableRow>
              <TableCell>{t('kjel.varmesystembruk')}</TableCell>
              <LeftBorderCell><Capitalize>{bioenergi.kjel.varmesystemBruk}</Capitalize></LeftBorderCell>
            </TableRow>
          )}
          {bioenergi.kjel.gulvvarme && (
            <TableRow>
              <TableCell>{t('kjel.gulvvarme.label')}</TableCell>
              <LeftBorderCell>{t(`kjel.gulvvarme.${bioenergi.kjel.gulvvarme}`)}</LeftBorderCell>
            </TableRow>
          )}
          {bioenergi.kjel.radiator && (
            <TableRow>
              <TableCell>{t('kjel.radiator.label')}</TableCell>
              <LeftBorderCell>{t(`kjel.radiator.${bioenergi.kjel.radiator}`)}</LeftBorderCell>
            </TableRow>
          )}
          {bioenergi.kjel.varmesentral && (
            <TableRow>
              <TableCell>{t('kjel.varmesentral.label')}</TableCell>
              <LeftBorderCell>{t(`kjel.varmesentral.${bioenergi.kjel.varmesentral}`)}</LeftBorderCell>
            </TableRow>
          ) &&
            bioenergi.kjel.varmesentralInstallasjonsAr && (
              <TableRow>
                <TableCell>{t('kjel.varmesentral.varmesentralInstallasjonsAr')}</TableCell>
                <LeftBorderCell>{bioenergi.kjel.vetVarmesentralInstallasjonsAr ? bioenergi.kjel.varmesentralInstallasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: bioenergi.kjel.varmesentralInstallasjonsAr })}</LeftBorderCell>
              </TableRow>
            )}
          {bioenergi.kjel.serviceGjennomfortSiste2Ar && (
            <TableRow>
              <TableCell>{t('kjel.serviceGjennomfortSiste2Ar')}</TableCell>
              <LeftBorderCell>{t(`kjel.${bioenergi.kjel.serviceGjennomfortSiste2Ar}`)}</LeftBorderCell>
            </TableRow>
          )}
        </Fragment>
      )}

      {bioenergi.kaminMedVannbarenVarme && (
        <Fragment>
          <AccentedTableRow>
            <TableCell colSpan={2}>{t('kjelMedKamin.label')}</TableCell>
          </AccentedTableRow>
          {bioenergi.kaminMedVannbarenVarme.installasjonsAr && (
            <TableRow>
              <TableCell>{t('kjelMedKamin.installasjonsar')}</TableCell>
              <LeftBorderCell>{bioenergi.kaminMedVannbarenVarme.vetInstallasjonsAr ? bioenergi.kaminMedVannbarenVarme.installasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: bioenergi.kaminMedVannbarenVarme.installasjonsAr })}</LeftBorderCell>
            </TableRow>
          )}
          {bioenergi.kaminMedVannbarenVarme.bruk && (
            <TableRow>
              <TableCell>{t('kjelMedKamin.bruk.label')}</TableCell>
              <LeftBorderCell>{t(`kjelMedKamin.bruk.${bioenergi.kaminMedVannbarenVarme.bruk}`)}</LeftBorderCell>
            </TableRow>
          )}
          {bioenergi.kaminMedVannbarenVarme.varmesystemBruk && (
            <TableRow>
              <TableCell>{t('kjelMedKamin.varmesystembruk')}</TableCell>
              <LeftBorderCell><Capitalize>{bioenergi.kaminMedVannbarenVarme.varmesystemBruk}</Capitalize></LeftBorderCell>
            </TableRow>
          )}
          {bioenergi.kaminMedVannbarenVarme.gulvvarme && (
            <TableRow>
              <TableCell>{t('kjelMedKamin.gulvvarme.label')}</TableCell>
              <LeftBorderCell>
                {t(`kjelMedKamin.gulvvarme.${bioenergi.kaminMedVannbarenVarme.gulvvarme}`)}
              </LeftBorderCell>
            </TableRow>
          )}
          {bioenergi.kaminMedVannbarenVarme.radiator && (
            <TableRow>
              <TableCell>{t('kjelMedKamin.radiator.label')}</TableCell>
              <LeftBorderCell>
                {t(`kjelMedKamin.radiator.${bioenergi.kaminMedVannbarenVarme.radiator}`)}
              </LeftBorderCell>
            </TableRow>
          )}
          {bioenergi.kaminMedVannbarenVarme.varmesentral && (
            <TableRow>
              <TableCell>{t('kjel.varmesentral.label')}</TableCell>
              <LeftBorderCell>
                {t(`kjel.varmesentral.${bioenergi.kaminMedVannbarenVarme.varmesentral}`)}
              </LeftBorderCell>
            </TableRow>
          ) &&
            bioenergi.kaminMedVannbarenVarme.varmesentralInstallasjonsAr && (
              <TableRow>
                <TableCell>{t('kjel.varmesentral.varmesentralInstallasjonsAr')}</TableCell>
                <LeftBorderCell>{bioenergi.kaminMedVannbarenVarme.vetVarmesentralInstallasjonsAr ? bioenergi.kaminMedVannbarenVarme.varmesentralInstallasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: bioenergi.kaminMedVannbarenVarme.varmesentralInstallasjonsAr })}</LeftBorderCell>
              </TableRow>
            )}
          {bioenergi.kaminMedVannbarenVarme.serviceGjennomfortSiste2Ar && (
            <TableRow>
              <TableCell>{t('kjel.serviceGjennomfortSiste2Ar')}</TableCell>
              <LeftBorderCell>
                {t(`kjel.${bioenergi.kaminMedVannbarenVarme.serviceGjennomfortSiste2Ar}`)}
              </LeftBorderCell>
            </TableRow>
          )}
        </Fragment>
      )}
    </Fragment>
  );
};
